function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function _createClass(Constructor, protoProps, staticProps) {if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;}import ModelPartsSearchProvider from './providers/ModelPartsSearchProvider';
import PropertiesSearchProvider from './providers/PropertiesSearchProvider';
import TextSearchProvider from './providers/TextSearchProvider';

export var SearchManager = /*#__PURE__*/function () {
  function SearchManager(viewer) {_classCallCheck(this, SearchManager);
    this.viewer = viewer;
    this.searchProviders = new Map();
  }

  /**
     * Add Search Provider Class to list of providers within SearchManager 
     * @param {SearchProvider} searchProvider 
     */_createClass(SearchManager, [{ key: "addSearchProvider", value: function addSearchProvider(
    SearchProvider) {
      if (!this.searchProviders.has(SearchProvider)) {
        this.searchProviders.set(
        SearchProvider, new SearchProvider(this.viewer));

      }
    } }, { key: "search",

    /**
                           * Performs search in search providers
                           * @param {string} userInput - search query input from user.
                           * @returns {Promise} Function returns a Promise with array of results from providers.
                           */value: function search(
    userInput) {var _this = this;
      return new Promise(function (resolve, reject) {
        var searchQuery = _this.prepareSearchInput(userInput);
        var promises = [];

        _this.searchProviders.forEach(function (searchProvider) {
          var promise = searchProvider.search(searchQuery);
          var searchProviderId = searchProvider.getProviderId();
          promise.id = searchProviderId;
          promises.push(promise);
        });

        Promise.all(promises).then(function (results) {
          var res = {};

          results.forEach(function (result, index) {
            var currentId = promises[index].id;
            res[currentId] = result;
          });
          resolve(res);
        }).
        catch(reject);

      });
    } }, { key: "removeAllProviders",

    /**
                                       * Remove search providers
                                       */value: function removeAllProviders()
    {
      this.searchProviders.clear();
    } }, { key: "removeProvider",

    /**
                                   * Remove specific search provider
                                   */value: function removeProvider(
    SearchProvider) {
      this.searchProviders.delete(SearchProvider);
    } }, { key: "prepareSearchInput",

    /**
                                       * Basic string handling.
                                       * @param {string} searchQuery - search query input
                                       */value: function prepareSearchInput(
    searchQuery) {
      return searchQuery.toLowerCase();
    } }]);return SearchManager;}();


var namespace = AutodeskNamespace('Autodesk.Viewing.Search');
namespace.SearchManager = SearchManager;
namespace.ModelPartsSearchProvider = ModelPartsSearchProvider;
namespace.PropertiesSearchProvider = PropertiesSearchProvider;
namespace.TextSearchProvider = TextSearchProvider;